import esES from './es-ES.json';
import ptBR from './pt-BR.json';
import ptPT from './pt-PT.json';
import enUS from './en-US.json';
import frFR from './fr-FR.json';

export const translations = {
  ptBR,
  ptPT,
  enUS,
  esES,
  frFR,
};
